import { countriesList, swapDomain } from '@archipro-website/localisation';
import type { SupportedCountry } from '@archipro-website/localisation';
import type { TopnavClientEnvironment } from '../types';

export const pathsThatShouldRedirectToHome = [
    'product',
    'professional',
    'project',
    'article',
];

/** Builds the target URL when switching from one country to another. */
export const buildCountryLink = (
    env: TopnavClientEnvironment,
    fromCountry: SupportedCountry,
    toCountry: SupportedCountry,
): string => {
    const host = env.host || countriesList[toCountry].domain;

    if (env.version === 'local') {
        return 'https://' + host;
    }

    return 'https://' + swapDomain(host, fromCountry, toCountry);
};
